import { useTranslation } from "react-i18next";
import { PUBLIC_LANGS } from "@/i18n";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();

  return (
    <label className={`relative inline-flex items-center ${compact ? "w-full" : ""}`}>
      <span className="sr-only">Language</span>
      <select
        data-testid="language-switcher"
        value={i18n.language?.slice(0, 2) || "en"}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
        className={`bg-white border border-border text-navy text-xs font-semibold tracking-wide outline-none focus:border-gold cursor-pointer ${
          compact ? "w-full py-3 px-3" : "h-10 px-3 min-w-[7.5rem]"
        }`}
      >
        {PUBLIC_LANGS.map((l) => (
          <option key={l.code} value={l.code}>
            {l.native}
          </option>
        ))}
      </select>
    </label>
  );
}
